export default "__VITE_ASSET__Db9Wwa0X__"